import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { history, store } from './store'
import App from './app/root';
import 'sanitize.css/sanitize.css'
import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';

const target = document.querySelector('#root')
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </Provider>,
  target
)



// WEBPACK FOOTER //
// ./src/index.js